import { Grid } from '@workspace/ui/components/Grid';
import { cn } from '@workspace/ui/lib/utils';
import { Fragment, forwardRef } from 'react';

import { TileCard } from '../TileCard';
import type { CategoriesTilesProps } from './types';
import { useCategoriesTilesSlots } from './useCategoriesTilesSlots';

export const CategoriesTiles = forwardRef<HTMLDivElement, CategoriesTilesProps>(
  ({ items, children, renderTileWrapper, className, ...props }, ref) => {
    const slots = useCategoriesTilesSlots(children);

    if (!items.length) return null;

    return (
      <div
        ref={ref}
        {...props}
        className={cn('mt-6 flex flex-col gap-6 md:gap-8', className)}
      >
        {slots.header}
        <Grid cols="2-3-4" className="gap-x-2 gap-y-6 md:gap-4">
          {items.map((item) => {
            const tile = (
              <TileCard
                title={item.title}
                imageUrl={item.imageUrl}
                imageAlt={item.imageAlt}
              />
            );

            return (
              <Fragment key={item.id}>
                {renderTileWrapper ? renderTileWrapper(item, tile) : tile}
              </Fragment>
            );
          })}
        </Grid>
      </div>
    );
  },
);

CategoriesTiles.displayName = 'CategoriesTiles';
